import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './store/mutations'
import actions from './store/actions'
// http://219.222.189.62:8080
// 47D40B26ADFEC9BDF057D402785FA115
// {
//   "siteId": "47D40B26ADFEC9BDF057D402785FA115",
//   "locationId":1,
//   "languageId":1
//  }
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    data: {},
    defaultPayload: {
      locationId: 1,
      languageId: Number(window.sessionStorage.getItem('languageId')) || -1,
    },
  },
  mutations,
  actions,
})
